export class DisablePipelineTrackers {
  static CANCEL_JOB_CLICK = '[Disable Pipeline] cancel job click';
}
